import gql from 'graphql-tag';

export default gql`
  mutation updateProductSupplier($input: UpdateProductSupplierInput!) {
    updateProductSupplier(input: $input) {
      success
      data {
        id
        productId
        supplierId
        invoiceName
        invoiceUom
        supplierName
      }
    }
  }
`;
